module.exports = "/_next/static/images/WirelessCardImage-0a53c47e37f66ec218cad815d72d4481.webp";